<script setup lang="ts">
defineSlots<{ default: () => unknown }>();
</script>
<template>
  <section class="px-4">
    <slot name="default"></slot>
  </section>
</template>
<style scoped></style>
